import React from "react";

function Footer() {
  return (
    <footer>
      <div>
        &copy; {new Date().getFullYear()} Anshu Raj. All rights reserved.
      </div>
      <div>
        Built with React &mdash; Designed by Anshu Raj
      </div>
    </footer>
  );
}

export default Footer;
